import { Collapse } from "@mantine/core";

import { useCollapsable } from "../../Collapsable";

import type { CollapseProps } from "@mantine/core";
import type { FC, ReactNode } from "react";

export type CollapsableCollapseProps = {
  children?: ReactNode | ((opened: boolean) => ReactNode);
  keepMounted?: boolean;
} & Omit<CollapseProps, "in">;

export const CollapsableCollapse: FC<CollapsableCollapseProps> = ({
  children,
  keepMounted = true,
}) => {
  const { opened } = useCollapsable();

  return (
    <Collapse in={opened}>
      {typeof children === "function" ? children(opened) : (keepMounted || opened) && children}
    </Collapse>
  );
};
